import React from 'react';

export const AdminKpiGrid = ({ stats }) => (
  <div className="kpi-grid" style={{ marginBottom: '1.5rem' }}>
    {[
      { label: 'Total Users', value: stats?.total_users || 0, color: '#0076A3' },
      { label: 'Total Jobs', value: stats?.total_jobs || 0, color: '#059669' },
      { label: 'Total Resumes', value: stats?.total_resumes || 0, color: '#D97706' },
      { label: 'Interviews', value: stats?.total_interview_sessions || 0, color: '#F2600C' },
    ].map(({ label, value, color }) => (
      <div key={label} className="kpi-tile">
        <div className="kpi-label">{label}</div>
        <div className="kpi-value" style={{ color }}>{value}</div>
      </div>
    ))}
  </div>
);
